import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { Table } from "../../../../../../../../../utils/types"
import { Box, Icon, IconButton, Tooltip, Typography } from "@mui/material"
import { icons } from "../../../../../../../../../utils/icons"
import { useStyles } from "../styles"
import { FilterBody } from "../../../../../../../../../hooks/filter/typing"
import { Activities, Activity, Destination, Local, LocalStorageData } from "../types"
import { returnQuery } from "../../../../../../../../../utils/methods/returnQuery"
import { loogbookServiceFetch } from "../../../../../../../../../utils/constants/callService"
import { formatUsersDataListResponse, formatUsersDataUnitsResponse, transformErrorActivity } from "../../../../../../../../../service/logbook/format/activity"
import { UsersListResponse } from "../../../../../../../../../service/logbook/response"
import { getLocalStorage } from "../../../../../../../../../utils/crud/crypt"
import { DestinationType } from "../enums/destinationType"
import { formatBodyToCreateActivities } from "../../../../../../../../../service/logbook/body"
import { Roles, Types } from "../../../../../../../../../utils/enums"
import { SnackbarFormat } from "../../../../../../../../../utils/types/generals"



const useBody = (filter: FilterBody, formatFilter: Record<string, string>, formatFilterUnity: Record<string, string>, filterUnity: FilterBody) => {

  const { t } = useTranslation()
  const styles = useStyles()
  const [loading, setLoading] = useState({
    users: false,
    activityByUser: false,
    units: false,
    subtmitActivity: false
  })
  const [open, setOpen] = useState<boolean>(false)
  const [activities, setActivities] = useState<Activities>([])
  const [totalPages, setTotalPages] = useState(0)
  const [snackbar, setSnackbar] = useState<SnackbarFormat>()
  const [usersSelected, setUsersSelected] = useState<number[]>([])
  const [usersSelectedInActivity, setUsersSelectedInActivity] = useState<number[]>([])
  const [usersData, setUsersData] = useState<UsersListResponse[]>([])
  const refTime = useRef<NodeJS.Timeout | null>(null)
  const [destination, setDestination] = useState<Destination | undefined>(undefined)
  const [destinationFinal, setDestinationFinal] = useState<Destination | undefined>(undefined)
  const [idOwnUser, setIdOwnUser] = useState<number | null>(null)
  const [allUsers, setAllUsers] = useState(false)
  const [idOnlyOneUser, setIdOnlyOneUser] = useState<number | null>(null)
  const [disabled, setDisabled] = useState<{ step1: boolean, step2: boolean }>({ step1: false, step2: false })

  const config = (value: boolean) => {
    setopenField(value)
  }

  const columnUsers = [
    {
      id: 'curp',
      label: t('general.tags.curp'),
      sortable: true,
    },
    {
      id: 'firstName',
      label: t('general.tags.name'),
      sortable: true,
    },
    {
      id: 'lastName',
      label: t('general.tags.lastName'),
      sortable: true,
    },
    {
      id: 'gender',
      label: t('general.tags.gender'),
      sortable: true,
      renderCell: (params: any) => {
        const gender = params.row?.gender
        return (
          <Typography sx={styles.user} className="w-full">
            {t(`general.fields.gender.${gender > 1 ? '3' : gender + 1}`)}
          </Typography>
        )
      },
    },
    {
      id: 'roleName',
      label: t('general.tags.role'),
      sortable: true,
      renderCell: (params: any) => {
        const role = params.row?.roleName
        return (
          <Box >
            {!!role ? (
              <>
                {!!role && (
                  <Typography sx={styles.user} className="w-full">
                    {role}
                  </Typography>
                )}
              </>
            ) : (
              <Typography sx={styles.user} className="w-full">
                {'N/A'}
              </Typography>
            )}
          </Box>
        )
      },
    },
    {
      id: 'userTypeDescription',
      label: t('general.tags.userType'),
      sortable: true,
    },
  ]

  const columnActivity = [
    {
      id: 'curp',
      label: t('general.tags.curp'),
      sortable: true,
    },
    {
      id: 'firstName',
      label: t('general.tags.name'),
      sortable: true,
    },
    {
      id: 'lastName',
      label: t('general.tags.lastName'),
      sortable: true,
    },
    {
      id: 'role',
      label: t('general.tags.role'),
      sortable: true,
      renderCell: (params: any) => {
        const role = params.row?.role.description
        return (
          <Box >
            {!!role ? (
              <>
                {!!role && (
                  <Typography sx={styles.user} className="w-full">
                    {role}
                  </Typography>
                )}
              </>
            ) : (
              <Typography sx={styles.user} className="w-full">
                {'N/A'}
              </Typography>
            )}
          </Box>
        )
      },
    },
    {
      id: 'totalLogs',
      label: t('general.tags.activities'),
      sortable: true,
      renderCell: (params: any) => {
        return (<>
          <Typography sx={styles.totalActivities}>
            {params.row.activities?.length ?? 0}
          </Typography>
          {params.row.errors?.map((error: any, index: number) => (
            <Typography sx={styles.errorsText} key={index}>-{error}</Typography>
          ))}
        </>)
      },
    },
    {
      id: 'settings',
      label: t('department.form.tabs.settings'),
      /* minWidth: 50, */
      contentColumn: {
        justifyContent: 'center',
      },
      column: () => {
        return (
          <Box sx={styles.settingHeader}>
            <Tooltip title={t('breadBrumbs.assignActivity')}>
              <span>
                <IconButton
                  className='setting'
                  onClick={() => {
                    setOpen(true)
                    setActivities([])
                    setAllUsers(true)
                  }}
                >
                  {icons('calendar')}
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        )
      },
      renderCell: (params: any) => {
        return (
          <Box sx={styles.setting(!!params.row.activities?.length)}>
            <Tooltip title={t('breadBrumbs.assignActivity')}>
              <IconButton
                onClick={() => {
                  setOpen(true)
                  setActivities(params.row.activities)
                  setIdOnlyOneUser(params.row.id)
                  setAllUsers(false)
                }}
              >
                {icons('calendar')}
                {(!!params.row.activities?.length) && (
                  <Icon sx={styles.check}>{icons('check')}</Icon>
                )}
              </IconButton>
            </Tooltip>
          </Box>
        )
      },
    },

  ]

  const columnUnits = [
    {
      id: 'id',
      label: t('general.tags.id'),
      sortable: true,
    },
    {
      id: 'divisionDescription',
      label: t('general.tags.division'),
      sortable: true,
    },
    {
      id: 'zoneName',
      label: t('general.tags.zone'),
      sortable: true,
    },
    {
      id: 'name',
      label: t('general.tags.store_name'),
      sortable: true,
    },
  ]

  const [tableUnits, setTableUnits] = useState<Table>({ column: columnUnits, row: [] })
  const localStorage = getLocalStorage() as LocalStorageData;
  const newRow = { id: localStorage.id, curp: localStorage.curp, firstName: localStorage.firstName, lastName: localStorage.lastName, role: { description: localStorage.roleName }, activities }
  const isPartner = localStorage.role == Roles.PARTNER
  const [openField, setopenField] = useState(isPartner ? true : false)
  const [disabledUsers, setDisabledUsers] = useState<number[]>(isPartner ? [localStorage.id]:[])
  const [tableUsers, setTableUsers] = useState<Table>({ column: columnUsers, row: [] })
  const [tableUserActivity, setTableUserActivity] = useState<Table>(
    {
      column: columnActivity,
      row: isPartner ?
        [{
          activities: [],
          curp: localStorage.curp,
          firstName: localStorage.firstName,
          id: localStorage.id,
          lastName:localStorage.lastName,
          role: {
            description: localStorage.roleName
          }
        }]
        :
        []
    }
  )

  const getDataUsersList = async () => {
    const response = await loogbookServiceFetch.getUsersData({ query: returnQuery({ ...filter.query, filter: filter.query.filter?.replaceAll('+', '%2B') }, formatFilter) })

    const { row } = formatUsersDataListResponse({ response })
    setUsersData(row)
  }

  const getData = () => {
    getDataUsersList()
  }

  useEffect(() => {
    getData()
  }, [])

  const setUnityToDestination = () => {
    setDestinationFinal(destination)
  }

  const handleRowClickUnity = (index: number | string) => {

    const clickedRow = tableUnits.row.find(row => row.id === index); // Acceder a la fila solo si index es un número.

    setDestination(
      {
        latitude: clickedRow.latitude,
        longitude: clickedRow.longitude,
        name: clickedRow.name,
        type: DestinationType.UNITY,
        id: clickedRow.id,
        timeZone: clickedRow.storeTimeZone
      });

  };


  const handleActivities = (newActivities: Activity) => {
    setActivities((prev) => [...prev, newActivities])
  }

  const editActivity = (updateActivity: Activity, id: string) => {
    setActivities((prev) =>
      prev.map((activity) =>
        activity.id === id ? { ...activity, ...updateActivity } : activity
      )
    );
  }

  const deleteActivity = (id: string) => {
    setActivities((prevActivities) =>
      prevActivities.filter((activity) => activity.id !== id)
    );
  }


  const getUsersList = async () => {

    setLoading(prev => ({
      ...prev,
      users: true
    }))

    const response = await loogbookServiceFetch.getUsersData({ query: returnQuery({ ...filter.query, filter: filter.query.filter?.replaceAll('+', '%2B') }, formatFilter) })

    const { row } = formatUsersDataListResponse({ response })

    setTableUsers((prev) => ({ ...prev, row: row }))
    setUsersData((prev) => {
      // Crear un mapa con los IDs existentes en prev para validar rápidamente
      const existingIds = new Set(prev.map((user) => user.id));

      // Filtrar solo las filas nuevas que no estén en prev
      const newRows = row.filter((user) => !existingIds.has(user.id));

      // Retornar el estado actualizado con las nuevas filas añadidas
      return [...prev, ...newRows];
    });
    //setUsersData(row)

    setLoading(prev => ({
      ...prev,
      users: false
    }))
  }

  const getUnits = async () => {

    setLoading(prev => ({
      ...prev,
      units: true
    }))

    let asociate;
    let companyId;

    const company: Local = getLocalStorage()

    if (company.role == Roles.ADMIN) {
      asociate = false;
      companyId = null;
    } else {
      asociate = filterUnity.filterData.onlyHierarchy;
      companyId = company.company?.id;
    }

    const response = await loogbookServiceFetch.getUnits({ query: returnQuery({ ...filterUnity.query, filter: filterUnity.query.filter?.replaceAll('+', '%2B') }, formatFilterUnity), asociate: asociate, companyId: companyId })

    const { row, totalPages } = formatUsersDataUnitsResponse({ response })

    setTableUnits((prev) => ({ ...prev, row: row }))
    setTotalPages(totalPages)

    setLoading(prev => ({
      ...prev,
      units: false
    }))
  }

  const getUsersDataSteps2 = () => {


    setTableUserActivity((prev) => {
      const currentRows = prev.row;
      const newUsers = usersData.filter(user => usersSelected.includes(user.id));
      const idCurrentUsers = currentRows.map(user => user.id);

      const userOwn = currentRows.find(user => user.id == newRow.id)

      const addedUsers = newUsers.filter(user => !idCurrentUsers.includes(user.id));
      const updatedRows = currentRows.filter(user => usersSelected.includes(user.id));

      let filteredRows = [...updatedRows, ...addedUsers];

      if (openField) {
        const exists = currentRows.some((row) => row.id === newRow.id);
        if (!exists) {
          filteredRows = [...filteredRows, newRow];
        } else {
          filteredRows = [...filteredRows, userOwn]
        }
      } else {
        filteredRows = filteredRows.filter((row) => row.id !== newRow.id);
      }

      return {
        ...prev,
        row: filteredRows,
      };

    });

    setDisabledUsers((prev) => {
      const currentRows = tableUserActivity.row;
      const idCurrentUsers = currentRows.map(user => user.id);

      const userOwn = currentRows.find(user => user.id == newRow.id)

      const addedDisabledUsers = usersSelected.filter(id => !idCurrentUsers.includes(id));
      const removedDisabledUsers = idCurrentUsers.filter(id => !usersSelected.includes(id));

      let updatedDisabledUsers = [
        ...prev.filter((id) => !removedDisabledUsers.includes(id)),
        ...addedDisabledUsers,
      ];

      if (openField) {
        const exists = userOwn
        if (!exists) {
          updatedDisabledUsers = [...updatedDisabledUsers, newRow.id];
        } else {
          const validation = userOwn.activities.length
          if (!validation) {
            updatedDisabledUsers = [...updatedDisabledUsers, newRow.id];
          } else {
            updatedDisabledUsers = [...updatedDisabledUsers];
          }
        }

      } else {
        updatedDisabledUsers = updatedDisabledUsers.filter((id) => id !== newRow.id);
      }

      return updatedDisabledUsers;

    });

  };


  const assignActivities = () => {
    if (allUsers) {
      setTableUserActivity(prevState => ({
        ...prevState,
        row: prevState.row.map(user => ({
          ...user,
          activities: activities,
          errors: []
        })),
      }));

      if (!activities.length) {
        setDisabledUsers(tableUserActivity.row.map((row) => row.id));
        setUsersSelectedInActivity([])
      } else {
        setDisabledUsers([])
      }

    } else {
      setTableUserActivity(prevState => ({
        ...prevState,
        row: prevState.row.map(user =>
          user.id === idOnlyOneUser
            ? { ...user, activities: activities, errors: [] }
            : user
        ),
      }));

      if (!activities.length && idOnlyOneUser) {
        setDisabledUsers((prevUsers) => [...prevUsers, idOnlyOneUser]);
        setUsersSelectedInActivity((prevUsers) => prevUsers.filter((row) => row !== idOnlyOneUser));
      } else {
        setDisabledUsers(prevUsers => prevUsers.filter(user => user !== idOnlyOneUser));
      }

      //si actividades viene vacio agregar a disable a este usuario

    }

    setActivities([])
  }

  const handleSubmitActivities = async () => {
    setLoading(prev => ({
      ...prev,
      subtmitActivity: true
    }))

    const { body } = formatBodyToCreateActivities({ usersSelectedInActivity: usersSelectedInActivity, usersRow: tableUserActivity.row })


    const response = await loogbookServiceFetch.createActivitiesToAllUsers(body)

    if (response.dataWithErrors) {
      //sacar los que se crearon

      const updateRows = tableUserActivity.row.filter((row) => {
        const isSelected = usersSelectedInActivity.includes(row.id);
        const errorData = response.dataWithErrors.find((errorRow: any) => errorRow.user_assign === row.id);

        if (isSelected) {

          if (errorData?.data.length === 0) {
            // Si `data` está vacío, elimina la fila
            if (localStorage.id == errorData.user_assign) { setopenField(false) }
            return null;
            /* return { ...row, activities: [] }; */
          } else {
            setSnackbar({ message: t('loogbook.snackbar.errorMasiveActivities'), open: true, type: Types.ERROR })
            // Si `data` contiene actividades no creadas, actualiza las actividades del usuario
            /* row.activities = errorData?.data.map(transformDataToActivity); */

            const validIds = new Set(errorData?.data.map((item) => item.idActivity));

            row.activities = row.activities.filter((activity: Activity) => {
              if (validIds.has(activity.id)) {
                // Si el ID está en `data`, marcamos `error` como true
                activity.error = true;
                return true; // Mantenemos esta actividad
              }
              return false; // Eliminamos actividades no encontradas
            });


            //recorrer las actividades si el id de la actividad no se encuentra eliminarla y si se encuentra agregarle el error y el taxto del error y dejar el resto igual
            row.errors = transformErrorActivity(errorData, t);
            return row;
            /* return { ...row, activities: errorData?.data.map(transformDataToActivity) }; */
          }
        }

        return row

      })

      setTableUserActivity((prev) => ({ ...prev, row: updateRows }))

      const updatedUserIds = updateRows.map((row) => row.id);

      setUsersSelected(updatedUserIds);

      setUsersSelectedInActivity([])

    }


    setLoading(prev => ({
      ...prev,
      subtmitActivity: false
    }))

  }

  const closeSnackbar = () => {
    setSnackbar(undefined)
  }

  useEffect(() => {
    getUsersList()
  }, [])

  useEffect(() => {

    if (refTime.current) { clearTimeout(refTime.current) }
    refTime.current = setTimeout(() => {
      getUnits()
    }, 300)

  }, [filterUnity.query.all])

  useEffect(() => {

    setDisabled((prev) => ({
      ...prev,
      step1: !openField && !usersSelected.length,
    }));

  }, [openField, usersSelected.length])

  useEffect(() => {

    setDisabled((prev) => ({
      ...prev,
      step2: !usersSelectedInActivity.length,
    }));

  }, [usersSelectedInActivity.length])

  return { tableUsers, disabled, snackbar, isPartner, handleRowClickUnity, closeSnackbar, handleSubmitActivities, openField, config, usersSelectedInActivity, setUsersSelectedInActivity, disabledUsers, destination, assignActivities, allUsers, setUnityToDestination, idOwnUser, setIdOwnUser, setDestination, tableUserActivity, tableUnits, open, setOpen, activities, handleActivities, deleteActivity, destinationFinal, setDestinationFinal, editActivity, getUsersList, loading, totalPages, usersSelected, setUsersSelected, getUsersDataSteps2 }
}

export { useBody }